import { Clear as ClearIcon } from '@mui/icons-material'
import { Box, IconButton, Rating, Typography } from '@mui/material'

interface StarRatingsProps {
    starRating: number | null
    setStarRating: (value: number | null) => void
    setHover: (value: number) => void
    hover: number
    ratingPrecision?: number
    customLabels?: { [index: number]: string }
    canEdit?: boolean
}

const StarRatings = ({
    ratingPrecision = 0.5,
    customLabels = {},
    starRating,
    setStarRating,
    setHover,
    hover,
    canEdit = true,
}: StarRatingsProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                marginTop: '1rem',
            }}
        >
            {starRating !== null && (
                <Typography variant="body2" sx={{ minWidth: '2rem' }}>
                    {starRating.toFixed(1)}
                </Typography>
            )}
            <Rating
                disabled={!canEdit}
                precision={ratingPrecision}
                onChange={(_e: React.SyntheticEvent, value: number | null) => {
                    setStarRating(value)
                }}
                onChangeActive={(e: React.SyntheticEvent, newHover: number) => {
                    setHover(newHover)
                }}
                value={starRating}
            />
            {starRating !== null && starRating > 0 && canEdit && (
                <IconButton
                    size="small"
                    onClick={() => setStarRating(null)}
                    title="Clear rating"
                >
                    <ClearIcon fontSize="small" />
                </IconButton>
            )}
            <Typography
                variant="body2"
                sx={{
                    minWidth: '4rem',
                    visibility: starRating !== null ? 'visible' : 'hidden',
                }}
            >
                {starRating !== null &&
                    customLabels[hover !== -1 ? hover : starRating]}
            </Typography>
        </Box>
    )
}

export default StarRatings
